import { useMemo, useState } from "react";

const defaultSearchKeys = ["school_name", "block_name", "district_name", "udise_code"];
const emptyExtraSearchKeys = [];

export function useCtSchoolsModalFilters(schools = [], query = "", extraSearchKeys = emptyExtraSearchKeys) {
  const [blockFilter, setBlockFilter] = useState("");
  const [schoolFilter, setSchoolFilter] = useState("");

  const blockOptions = useMemo(() => {
    return [...new Set(schools.map((s) => s.block_name).filter(Boolean))].sort((a, b) => a.localeCompare(b));
  }, [schools]);

  const schoolOptions = useMemo(() => {
    const scoped = blockFilter
      ? schools.filter((s) => String(s.block_name || "") === blockFilter)
      : schools;
    return [...new Set(scoped.map((s) => s.school_name).filter(Boolean))].sort((a, b) => a.localeCompare(b));
  }, [schools, blockFilter]);

  const filtered = useMemo(() => {
    let result = schools;
    if (blockFilter) {
      result = result.filter((s) => String(s.block_name || "") === blockFilter);
    }
    if (schoolFilter) {
      result = result.filter((s) => String(s.school_name || "") === schoolFilter);
    }
    const q = query.trim().toLowerCase();
    if (!q) return result;

    const searchKeys = [...defaultSearchKeys, ...extraSearchKeys];
    return result.filter((s) =>
      searchKeys.some((key) => String(s[key] || "").toLowerCase().includes(q)),
    );
  }, [schools, blockFilter, schoolFilter, query, extraSearchKeys]);

  const resetFilters = () => {
    setBlockFilter("");
    setSchoolFilter("");
  };

  return {
    blockFilter,
    setBlockFilter,
    schoolFilter,
    setSchoolFilter,
    blockOptions,
    schoolOptions,
    filtered,
    resetFilters,
  };
}
